export default "__VITE_ASSET__CY9ro5Zi__"